import React from "react";
//import { Link } from "react-router-dom";
import Herospace from "../components/Herospace";
import InstructionListMobile from "../components/mobile/InstructionListMobile";
import useResponsive from "../hooks/useResponsive";
import { GameContext } from "../context/GameContext";
import InstructionsList from "../components/InstructionsList";
function StartView() {
  const { Mobile, Default } = useResponsive();
  const { setView } = React.useContext(GameContext);

  const handleClick = () => {
    setView("game");
  };

  return (
    <>
      <Herospace />
      <main className="start-view_main">
        <Default>
          <div className="instructions_container">
            <InstructionsList />
          </div>
        </Default>
        <Mobile>
          <div className="instructions_container-mobile">
            <InstructionListMobile />
          </div>
        </Mobile>

        <button className="active_button" onClick={handleClick}>
          Starta
        </button>
      </main>
    </>
  );
}

export default StartView;
